import { Container, Row, Col, Card, Image, Button } from 'react-bootstrap';
import PageHero from '../components/PageHero';

const sponsors = [
  
  {
    name: 'Aerosol Magee Scientific',
    country: 'Slovenia',
    logo: 'sponsors/sponsors_aerosol.webp',
    url: 'https://aerosolmageesci.com/',
    level: 'platinum',
    description:
      'Aerosol Magee Scientific develops and provides instruments and expertise for aerosol, black carbon and atmospheric measurements.',
  },
  {
    name: 'Aethlabs',
    country: 'USA',
    logo: 'sponsors/sponsors_aethlabs.webp',
    url: 'https://aethlabs.com/',
    level: 'gold',
    description:
      'Aethlabs develops portable and real-time air quality monitoring instruments for aerosol and black carbon measurements.',
  },
  {
    name: 'Topas',
    country: 'Germany',
    level: 'gold',
    logo: 'sponsors/sponsors_topas.webp',
    url: 'https://www.topas-gmbh.de/en',
    description:
      'Topas develops and manufactures aerosol generation, conditioning and particle measurement systems, as well as advanced solutions for filter and filter media testing.',
  },
  {
  name: 'Dado Lab',
  country: 'Italy',
  level: 'silver',
  logo: 'sponsors/sponsors_dado.webp',
  url: 'https://www.dadolab.com/en/',
  description:
    'Dado Lab develops innovative and reliable instruments for ambient air monitoring, emission sampling, occupational hygiene, gas conditioning and environmental analysis.',
  },
  {
    name: 'Cambustion',
    country: 'United Kingdom',
    level: 'silver',
    logo: 'sponsors/sponsors_cambustion.webp',
    url: 'https://www.cambustion.com/',
    description:
      'Cambustion develops advanced instrumentation for aerosol, particle and gas measurement, supporting applications in aerosol science, air quality, calibration, emissions and filtration research.',
  },
  
  {
    name: 'Gesellschaft für Aerosolforschung',
    country: 'Germany',
    logo: 'sponsors/sponsors_gaef.webp',
    url: 'https://www.info.gaef.de/',
    level: 'organizer',
    description:
      'GAeF is a scientific association dedicated to aerosol research and the exchange of knowledge across the aerosol science community.',
  },
  {
    name: 'University of Nova Gorica',
    country: 'Slovenia',
    logo: 'sponsors/sponsors_ung.webp',
    url: 'https://ung.si/en/',
    level: 'organizer',
    description:
      'The University of Nova Gorica is a research-oriented university with strong involvement in atmospheric science, environmental research and international collaboration.',
  },
  {
    name: 'National Institute of Chemistry',
    country: 'Slovenia',
    logo: 'sponsors/sponsors_ki.webp',
    url: 'https://www.ki.si/en/',
    level: 'organizer',
    description:
      'The National Institute of Chemistry is one of Slovenia’s leading research institutions, supporting scientific excellence across chemistry, materials and environmental research.',
  },
  {
    name: 'Jožef Stefan Institute',
    country: 'Slovenia',
    logo: 'sponsors/sponsors_jsi.webp',
    url: 'https://www.ijs.si/ijsw/V001/JSI',
    level: 'organizer',
    description:
      'The Jožef Stefan Institute is Slovenia’s largest research institute, covering a broad range of scientific and technological disciplines.',
  },
  
];

export default function Sponsors() {
  return (
    <div className="page-content">
      <PageHero
        eyebrow="Sponsors"
        title="Our sponsors"
        intro="EAC2027 is supported by institutions and organizations committed to aerosol science, research collaboration and scientific exchange."
      />

      <main className="info-page pt-5 pb-5">
        <Container className="pt-5">
          <Row className="justify-content-center">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2 className="h1">Become a sponsor</h2>
                <p>
                  Whether you wish to showcase a new product, engage with leading scientists, organize a user meeting, or increase your visibility within the aerosol community, EAC2027 provides an excellent platform to achieve your goals.
                </p>
                <p>
                  For sponsorship enquiries, please contact us at:{' '}
                  <a href="mailto:sponsors@eac2027.si">sponsors@eac2027.si</a>
                </p>
              </section>

              <section className="info-section">
                <h2>Showcase your solutions to the international aerosol community</h2>
                <p>
                  The European Aerosol Conference 2027 (EAC2027) will bring together researchers, environmental professionals, policymakers, and industry representatives from across Europe and beyond to discuss the latest developments in aerosol science, air quality, atmospheric measurements, health impacts, and aerosol technology.
                </p>
                <p>
                  We warmly invite <span className="text-marker">companies, organizations, scientific publishers, and service providers</span> to become sponsors of EAC2027.
                </p>
                <p>
                  The conference exhibition will be located in the Grand Reception Hall of Cankarjev dom, Ljubljana. Coffee breaks and lunches will be served within the exhibition area, ensuring continuous interaction between exhibitors and conference participants throughout the event.
                </p>
              </section>

              <section className="info-section">
                <h2>Why exhibit?</h2>
                <p>EAC2027 offers a unique opportunity to:</p>
                <ul>
                  <li>Present new instruments, technologies, software, and services to a highly specialized audience</li>
                  <li>Meet researchers, environmental agencies, universities, laboratories, and industrial users</li>
                  <li>Demonstrate products directly to current and future customers</li>
                  <li>Increase visibility within the international aerosol science community</li>
                  <li>Establish new collaborations and business opportunities</li>
                  <li>Engage with delegates throughout the entire conference</li>
                </ul>
              </section>

              <section className="info-section">
                <h2>Sponsorship Opportunities</h2>
                <p>
                  A variety of sponsorship opportunities are available, ranging <span className="text-marker">from exhibition packages to highly visible conference-wide activities.</span> Each category includes exhibition space, complimentary registrations, branding opportunities, conference recognition, and promotional visibility before and during the event.
                </p>
                <p>
                  Customized sponsorship packages can also be developed to match your organization's objectives and outreach goals.
                </p>
                <p>
                  <a href="mailto:sponsors@eac2027.si">Contact us for more information.</a>
                </p>
              </section>

              <section className="info-section">
                <h2 className="h1">EAC2027 Sponsors and Organizers</h2>
                <p>
                  EAC2027 is made possible through the support of <span className="text-marker">scientific associations, research institutions and organizations</span> that contribute to the advancement of aerosol science and international collaboration.
                </p>
              </section>
            </Col>
          </Row>

          <section className="info-section">
            <Row className="g-4  mb-5">
              {sponsors.map((sponsor) => (
                <Col md={6} lg={3} key={sponsor.name}>
                  <Card className="sponsor-card h-100">
                    <Card.Body>
                      <div className="sponsor-logo">
                        <span className={`sponsor-level sponsor-level--${sponsor.level}`}>
                          {sponsor.level}
                        </span>

                        <Image src={sponsor.logo} alt={sponsor.name} fluid />
                      </div>
                      <h3>{sponsor.name}</h3>
                      {sponsor.country && (
                        <p className="sponsor-country">
                          {sponsor.country}
                        </p>
                      )}
                      <p>{sponsor.description}</p>
                      <Button
                        as="a"
                        href={sponsor.url}
                        target="_blank"
                        rel="noreferrer"
                        variant="outline-eac"
                        size="sm"
                        className="mt-auto"
                      >
                        Visit website
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </section>
        </Container>
      </main>
    </div>
  );
}